/* eslint-disable camelcase */
/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { call, takeLatest, select, put } from 'redux-saga/effects';
import { get } from 'lodash';
import { locales, setNotification, getTranslated, searchElementMatch, CONFIGURATION_PROPERTY_TYPES, getLocalePropertyValue } from 'utils';
import * as ConfigurationTypes from '../types/configurationTypes';
import { getCarriersApi } from '../api/carrierApi';
import { getPropertyValuesApi } from '../api/propertyApi';
import * as ConfigurationApi from '../api/configurationApi';
import * as ConfigurationActions from '../actions/configurationActions';

const getLayout = state => state.layout;
const getConfiguration = state => state.configuration;

// L O A D   C A R R I E R S   &   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N
function* loadCarriersForConfigurationSaga(action) {
    try {
        const { locale } = yield select(getLayout);

        const params = {
            offset: 0,
            limit: 10,
            joins: JSON.stringify(['property']),
            filter: JSON.stringify({
                name: searchElementMatch(action.value, locale),
            }),
        };

        const result = yield getCarriersApi(params);
        yield put(ConfigurationActions.loadCarriersForConfigurationRes(action.key, result.data.hits));
    } catch (e) {
        yield put(ConfigurationActions.loadCarriersForConfigurationErr(action.key));
        console.log(e);
    }
}

export function* loadCarriersForConfigurationWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION, loadCarriersForConfigurationSaga);
}

function* loadPropertyValuesForConfigurationSaga(action) {
    try {
        const params = {
            offset: 0,
            limit: 999,
            filter: JSON.stringify({
                property: action.propertyID,
            }),
        };

        const result = yield getPropertyValuesApi(params);
        yield put(ConfigurationActions.loadPropertyValuesForConfigurationRes(result.data.hits));
    } catch (e) {
        yield put(ConfigurationActions.loadPropertyValuesForConfigurationErr());
        console.log(e);
    }
}

export function* loadPropertyValuesForConfigurationWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION, loadPropertyValuesForConfigurationSaga);
}
// L O A D   C A R R I E R S   &   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N


// A D D   N E W   C O N F I G U R A T I O N
function* addPropertyToConfiguration(data) {
    yield ConfigurationApi.addPropertyToConfigurationApi(data);
}

function* deletePropertyFromConfiguration(data) {
    yield ConfigurationApi.deletePropertyFromConfigurationApi(data);
}

function* updateConfigurationTranslate(action) {
    const type = 'add';
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            reseller_id: action.data.reseller_id,
            configuration_id: action.data.configuration_id,
        };

        const params = { bulk: [] };
        locales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === ConfigurationTypes.EDIT_CONFIGURATION)) {
                params.bulk.push({
                    ...data,
                    ...action.data[lc],
                });
            }
        });

        const result = yield ConfigurationApi.updateTranslateConfigurationApi(params);

        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }

        yield put(ConfigurationActions.updateTranslateConfigurationRes(type, true, true));
        yield delay(50);
        yield put(ConfigurationActions.updateTranslateConfigurationRes(type, false, false));
    } catch (e) {
        setNotification('error', locale, 'global.error', 'configuration.notification.translateErrorFunction');
        yield put(ConfigurationActions.updateTranslateConfigurationErr(type, false, false));
        console.log(e);
    }
}

function* addNewConfigurationSaga(action) {
    const { locale } = yield select(getLayout);
    const notification = {
        success: 'addNewConfigurationSuccess',
        error: 'addingNewConfigurationError',
    };

    if (action.data.isClone) {
        notification.success = 'cloneConfigurationSuccess';
        notification.error = 'cloningConfigurationError';
    }

    try {
        const { data } = action;
        data.configuration_properties = action.data.configurationProperties;

        const result = yield ConfigurationApi.addNewConfigurationApi(data);
        if (result.status === 202) {
            yield call(updateConfigurationTranslate, action);

            yield put(ConfigurationActions.addNewConfigurationRes(true));
            yield put(push('/factory/configurations/'));

            setNotification('success', locale, 'global.success', `configuration.notification.${notification.success}`);
            yield put(ConfigurationActions.addNewConfigurationRes(false));
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

            yield put(ConfigurationActions.addNewConfigurationErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', `configuration.notification.${notification.error}`);
        yield put(ConfigurationActions.addNewConfigurationErr(true));
        console.log(e);
    }
}

export function* addNewConfigurationWatcher() {
    yield takeLatest(ConfigurationTypes.ADD_NEW_CONFIGURATION, addNewConfigurationSaga);
}
// A D D   N E W   C O N F I G U R A T I O N


// A D D   B U L K   C O N F I G U R A T I O N S
function* addBulkConfiguration({ configuration, carrier_id, configuration_type, reseller }) {
    const progressResult = { configuration_id: configuration.configuration_id };
    const successResult = { ...progressResult, success: true, error: false };
    const errorResult = { ...progressResult, success: false, error: true };

    try {
        const name = configuration.configuration_properties.map(cp => (
            get(getLocalePropertyValue(cp.propertyValue.name.translate, 'en'), 'value', cp.propertyValue.name.original_name)
        )).join(', ');

        const dataConfiguration = {
            quantity_max: 0,
            reseller_id: reseller,
            name,
            language: 'be_en',
            configuration_id: configuration.configuration_id,
            is_enable: true,
            new_stock_quantity: 0,
            date_stock_checked: null,
            future_stock_quantity: 0,
            stock_quantity: 0,
            reset_extra_info: true,
            custom_format_details: {
                tolerance: null,
                media: null,
                dpi: null,
                max_height: null,
                max_width: null,
                min_height: null,
                min_width: null,
            },
            configuration_type,
            configuration_properties: configuration.configuration_properties.map((cp, i) => ({
                carrier_id,
                property_id: cp.property.id,
                property_value_id: cp.propertyValue.id,
                configuration_id: configuration.configuration_id,
                property_order: i + 1,
            })),
            extra_info: [],
        };

        const resultConfiguration = yield ConfigurationApi.addNewConfigurationApi(dataConfiguration);

        if (resultConfiguration.status === 202) {
            const translation = {
                reseller_id: reseller,
                configuration_id: configuration.configuration_id,
            };

            const dataTranslation = { bulk: [] };

            locales.filter(l => l !== 'en').forEach((lc) => {
                dataTranslation.bulk.push({
                    ...translation,
                    language: `be_${lc}`,
                    name: configuration.configuration_properties.map(cp => (
                        get(getLocalePropertyValue(cp.propertyValue.name.translate, lc), 'value', cp.propertyValue.name.original_name)
                    )).join(', '),
                });
            });

            const resultTranslation = yield ConfigurationApi.updateTranslateConfigurationApi(dataTranslation);

            if (resultTranslation.status === 202) {
                yield put(ConfigurationActions.updateProgressOfBulkConfigurations(successResult));
            } else {
                yield put(ConfigurationActions.updateProgressOfBulkConfigurations(errorResult));
            }
        } else {
            yield put(ConfigurationActions.updateProgressOfBulkConfigurations(errorResult));
        }
    } catch (e) {
        yield put(ConfigurationActions.updateProgressOfBulkConfigurations(errorResult));
        console.log(e);
    }
}

function* addBulkConfigurationsSaga(action) {
    try {
        const { configurations, carrier_id, configuration_type, reseller } = action.data;

        for (let i = 0; i < configurations.length; i += 1) {
            const configuration = configurations[i];

            try {
                yield call(addBulkConfiguration, { configuration, carrier_id, configuration_type, reseller });
            } catch (e) {
                yield put(ConfigurationActions.updateProgressOfBulkConfigurations({
                    configuration_id: configuration.configuration_id,
                    success: false,
                    error: true,
                }));
            }
        }

        yield put(ConfigurationActions.finishAddingBulkConfigurations());
    } catch (e) {
        console.log(e);
    }
}

export function* addBulkConfigurationsWatcher() {
    yield takeLatest(ConfigurationTypes.ADD_BULK_CONFIGURATIONS, addBulkConfigurationsSaga);
}
// A D D   B U L K   C O N F I G U R A T I O N S


// L O A D   E D I T A B L E   C O N F I G U R A T I O N
function* loadEditableConfigurationSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            filter: JSON.stringify({
                id: action.id,
                all: true,
            }),
        };

        const result = yield ConfigurationApi.getConfigurationsApi(params);

        if (result.data.hits.length > 0) {
            const hit = result.data.hits[0];

            if (hit.configuration_property[0] && hit.configuration_property[0].carrier_id) {
                const paramsCarrier = {
                    filter: JSON.stringify({
                        id: hit.configuration_property[0].carrier_id,
                    }),
                    joins: JSON.stringify(['property']),
                };

                const getCarrierResult = yield getCarriersApi(paramsCarrier);

                if (getCarrierResult.status === 200) {
                    const carrier = getCarrierResult.data.hits[0];
                    hit.carrier = [carrier];
                    yield put(ConfigurationActions.loadEditableConfigurationRes(hit));
                }
            } else {
                if (CONFIGURATION_PROPERTY_TYPES.includes(hit.configuration_type)) {
                    setNotification('warning', locale, 'global.warning', 'configuration.notification.loadEditableConfigurationCarrierWarn', { duration: null });
                }

                hit.carrier = [];
                yield put(ConfigurationActions.loadEditableConfigurationRes(hit));
            }
        } else {
            yield put(push('/404'));
            yield put(ConfigurationActions.loadEditableConfigurationRes(null));
        }
    } catch (e) {
        yield put(ConfigurationActions.loadEditableConfigurationErr(getTranslated('configuration.notification.loadEditableConfigurationError', locale)));
        console.log(e);
    }
}

export function* loadEditableConfigurationWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION, loadEditableConfigurationSaga);
}
// L O A D   E D I T A B L E   C O N F I G U R A T I O N


// E D I T   C O N F I G U R A T I O N
function* editConfigurationSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const { edit } = yield select(getConfiguration);

    try {
        const { data } = action;

        const result = yield ConfigurationApi.editConfigurationApi(data);
        if (result.status === 202) {
            yield call(updateConfigurationTranslate, action);

            const previousConfigProps = edit.data.configuration_property.map((cp, i) => ({
                configuration_id: action.data.configuration_id,
                property_id: cp.property_id,
                property_value_id: cp.property_value_id,
                carrier_id: cp.carrier_id,
                property_order: i + 1,
            }));

            for (let i = 0; i < previousConfigProps.length; i += 1) {
                yield call(deletePropertyFromConfiguration, previousConfigProps[i]);
                yield delay(200);
            }

            const { configurationProperties } = action.data;
            for (let i = 0; i < configurationProperties.length; i += 1) {
                yield call(addPropertyToConfiguration, configurationProperties[i]);
                yield delay(200);
            }

            yield put(ConfigurationActions.editConfigurationRes(true));
            yield put(push('/factory/configurations/'));

            setNotification('success', locale, 'global.success', 'configuration.notification.editConfigurationSuccess');
            yield put(ConfigurationActions.editConfigurationRes(false));
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

            yield put(ConfigurationActions.editConfigurationErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'configuration.notification.editingConfigurationError');
        yield put(ConfigurationActions.editConfigurationErr(true));
        console.log(e);
    }
}

export function* editConfigurationWatcher() {
    yield takeLatest(ConfigurationTypes.EDIT_CONFIGURATION, editConfigurationSaga);
}
// E D I T   C O N F I G U R A T I O N


// L O A D   C O N F I G U R A T I O N S
function* loadConfigurationsSaga() {
    const { locale } = yield select(getLayout);
    const { offset, limit, filters, sort } = yield select(getConfiguration);

    try {
        const params = {
            offset,
            limit,
            joins: JSON.stringify(['carriers']),
        };

        const sendFilters = {
            all: true,
        };

        if (filters['name.translate'] !== '') {
            sendFilters['name.translate'] = searchElementMatch(filters['name.translate'], locale);
        }

        if (filters['configuration_property.carrier_id'].length > 0) {
            sendFilters['configuration_property.carrier_id'] = filters['configuration_property.carrier_id'];
        }

        if (filters['configuration_property.property_value_id'].length > 0) {
            sendFilters.and = filters['configuration_property.property_value_id'].map(cp => ({
                'configuration_property.property_value_id': cp,
            }));
        }

        if (filters.configuration_type.length > 0) {
            sendFilters.configuration_type = filters.configuration_type;
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ 'name.original_name': sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const result = yield ConfigurationApi.getConfigurationsApi(params);

        if (result.status === 200) {
            yield put(ConfigurationActions.loadConfigurationsRes(result.data));
        }
    } catch (e) {
        yield put(ConfigurationActions.loadConfigurationsErr());
        console.log(e);
    }
}

export function* loadConfigurationsWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_CONFIGURATIONS, loadConfigurationsSaga);
}
// L O A D   C O N F I G U R A T I O N S


// L O A D   C A R R I E R S   F O R   C O N F I G U R A T I O N   F I L T E R
function* loadCarriersForConfigurationFilterSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const params = {
            offset: 0,
            limit: 10,
            filter: JSON.stringify({
                name: searchElementMatch(action.value, locale),
            }),
            sort_by: JSON.stringify({ created_at: -1 }),
        };

        const result = yield getCarriersApi(params);
        yield put(ConfigurationActions.loadCarriersForConfigurationFilterRes(result.data.hits));
    } catch (e) {
        yield put(ConfigurationActions.loadCarriersForConfigurationFilterErr());
        console.log(e);
    }
}

export function* loadCarriersForConfigurationFilterWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER, loadCarriersForConfigurationFilterSaga);
}
// L O A D   C A R R I E R S   F O R   C O N F I G U R A T I O N   F I L T E R


// L O A D   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N   F I L T E R
function* loadPropertyValuesForConfigurationFilterSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const params = {
            offset: 0,
            limit: 999,
            filter: JSON.stringify({
                'name.translate': searchElementMatch(action.value, locale),
            }),
            sort_by: JSON.stringify({ created_at: -1 }),
        };

        const result = yield getPropertyValuesApi(params);
        yield put(ConfigurationActions.loadPropertyValuesForConfigurationFilterRes(result.data.hits));
    } catch (e) {
        yield put(ConfigurationActions.loadPropertyValuesForConfigurationFilterErr());
        console.log(e);
    }
}

export function* loadPropertyValuesForConfigurationFilterWatcher() {
    yield takeLatest(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER, loadPropertyValuesForConfigurationFilterSaga);
}
// L O A D   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N   F I L T E R


// T O G G L E   C O N F I G U R A T I O N   S T A T U S
function* toggleConfigurationStatusSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        let params = {};

        if (action.multiple) {
            params = action.bulkParams;
        } else {
            params = { configuration_id: action.id[0] };
        }

        const result = yield ConfigurationApi.toggleConfigurationStatusApi(action.status, params);

        if (result.status === 202) {
            if (!action.multiple) {
                setNotification('success', locale, 'global.success', `configuration.notification.toggleStatus.${action.status}.success`);
                yield put(ConfigurationActions.toggleConfigurationStatusRes());
            } else {
                setNotification('success', locale, 'global.success', `configuration.notification.bulkStatus.${action.status}.success`);
                yield put(ConfigurationActions.bulkCheckedConfigurationsRes());
            }

            yield call(loadConfigurationsSaga, {});
        } else if (!action.multiple) {
            setNotification('error', locale, 'global.error', `configuration.notification.toggleStatus.${action.status}.error`);
            yield put(ConfigurationActions.toggleConfigurationStatusErr());
        } else {
            setNotification('error', locale, 'global.error', `configuration.notification.bulkStatus.${action.status}.error`);
            yield put(ConfigurationActions.bulkCheckedConfigurationsErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', `configuration.notification.toggleStatus.${action.status}.error`);
        yield put(ConfigurationActions.toggleConfigurationStatusErr());
        console.log(e);
    }
}

export function* toggleConfigurationStatusWatcher() {
    yield takeLatest(ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS, toggleConfigurationStatusSaga);
}
// T O G G L E   C O N F I G U R A T I O N   S T A T U S


// B U L K   C H E C K E D   C O N F I G U R A T I O N S
function* bulkCheckedConfigurationsSaga(action) {
    const { locale } = yield select(getLayout);
    const { bulk, ids } = action;

    try {
        if (bulk === 'disable' || bulk === 'enable') {
            const bulkParams = { bulk: [] };
            for (let i = 0; i < ids.length; i += 1) {
                bulkParams.bulk = bulkParams.bulk.concat({ configuration_id: ids[i] });
            }

            yield call(toggleConfigurationStatusSaga, {
                status: bulk,
                bulkParams,
                multiple: true,
            });
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', `configuration.notification.bulkStatus.${bulk}.error`);
        yield put(ConfigurationActions.bulkCheckedConfigurationsErr());
        console.log(e);
    }
}

export function* bulkCheckedConfigurationsWatcher() {
    yield takeLatest(ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS, bulkCheckedConfigurationsSaga);
}
// B U L K   C H E C K E D   C O N F I G U R A T I O N S
